// extracted by mini-css-extract-plugin
module.exports = {"terms":"pc_terms__ZY63l","main":"pc_main__MQsxm"};